import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import fileDownload from 'js-file-download';
import store from '@/state/store';
import { tierReportAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';
import { multipleReplace } from '@/utils/common-utils';


class TierreportState {
    public loading: boolean = false

    public tierReport: object = {}

    public tierReportGraph: object = {}
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'tierreport',
})
class TierreportStore extends VuexModule {
    tierreportStore: TierreportState = new TierreportState();

    @Mutation
    TIERREPORT_REINITIALIZE() {
        this.tierreportStore = new TierreportState();
    }

    @Mutation
    SET_TIERREPORT_LOADING(loading: boolean) {
        this.tierreportStore.loading = loading;
    }

  @Mutation
    SET_TIERREPORT_REPORT(response: object) {
        this.tierreportStore.tierReport = response || {};
    }

  @Mutation
  SET_TIERREPORT_GRAPH_REPORT(response: object) {
      this.tierreportStore.tierReportGraph = response || {};
  }

    @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_TIERREPORT_LOADING', show);
  }

    @Action({ rawError: true })
    destroyTierreport() {
        this.context.commit('TIERREPORT_REINITIALIZE');
    }

  @Action({ rawError: true })
    getTierReport(payload: Payload = new Payload()) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendGet(tierReportAPI.getTierReport, payload.data).then((response) => {
                if (payload.storeData) {
                    this.context.commit('SET_TIERREPORT_REPORT', response.data);
                }
                this.showLoader(false);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  tierReportExport(payload: Payload = new Payload()) {
      this.showLoader(false);
      return new Promise((resolve, reject) => {
          sendGet(tierReportAPI.getTierReport, payload.data).then((response) => {
              fileDownload(response.data, 'tier-report.csv');
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getTierGraphReport(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(tierReportAPI.getTierReportChart, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_TIERREPORT_GRAPH_REPORT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}


export default getModule(TierreportStore);
